import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.replace";
import Vue from "vue";
import * as dayjs from "dayjs";
Vue.filter('NumberFormat', function (value) {
  if (!value) {
    return '0';
  }

  var intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断

  return intPartFormat;
});
Vue.filter('dayjs', function (dataStr) {
  var pattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';
  return dayjs(dataStr).format(pattern);
});
Vue.filter('moment', function (dataStr) {
  var pattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';
  return dayjs(dataStr).format(pattern);
});
/** 字符串超长截取省略号显示 */

Vue.filter('ellipsis', function (value) {
  var vlength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;

  if (!value) {
    return "";
  }

  console.log('vlength: ' + vlength);

  if (value.length > vlength) {
    return value.slice(0, vlength) + '...';
  }

  return value;
});